<template>
  <div>
  	<div class="btns-wrap">
  		<div>
  	    <el-button type="primary" class="addBtn" @click="toArticleCategoryClick">文章分类</el-button>
  	    <el-button type="primary" class="addBtn" @click="toArticleLabelClick">文章标签</el-button>
			<div class="input-area">
				<el-input
						v-model="keyword_search"
						placeholder="请输入内容"
						clearable
						@clear="clearClick"
				/>
			</div>
			<el-button
					type="primary"
					class="searchBtn"
					@click="handlerSearch"
			>搜索</el-button>
  	  </div>
  	  <el-button type="primary" class="addBtn" @click="addBtnClick">添加文章</el-button>
  	</div>
    <div class="table-wrap">
    	<el-table
		    :data="tableData"
		    border
		    style="width: 100%">
		    <el-table-column
		      prop="sort"
		      label="权重"
		      align="center"
		      width="80"
        >
		    </el-table-column>

		    <el-table-column
		      label="封面图片"
		      align="center"
        >
          <template slot-scope="scope">
             <img :src="imgDomain + scope.row.article_icon"  class="project-img">
          </template>
		    </el-table-column>
        <el-table-column
          prop="article_title"
          label="文章标题"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="article_subtitle"
          label="文章副标题"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="article_class_name"
          label="所属类别"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="create_time"
          label="添加时间"
          align="center"
        >
        </el-table-column>
		    <el-table-column
		      label="操作"
		      align="center"
		      width="180"
        >
         <template slot-scope="scope">
         	  <div class="operation-wrap">
         	    <span class="opration-item" @click="editArticleClick(scope.row)">编辑</span>
         	    <span class="opration-item" @click="changeRecommendStatus(scope.row, '1')" v-if="scope.row.is_recommend === '1'">设为推荐</span>
              <span class="opration-item" @click="changeRecommendStatus(scope.row, '2')" v-if="scope.row.is_recommend === '2'">取消推荐</span>
         	    <span class="opration-item" @click="deleteArticleClick(scope.row)">删除</span>
         	  </div>
         </template>
		    </el-table-column>
		  </el-table>
		  <common-pagination
			  :total="total"
        :page_size="page_size"
			  @size-change="handelPagesizeChange"
			  @page-change="handlePageChange"
			></common-pagination>
    </div>
    <common-dialog
    :title="dialogTitle"
    :dialogVisible="dialogVisible"
    @cancel="dialogCancelClick"
    @confirm="dialogConfirmClick"
    @dialog-close="dialogClose"
		>
      <div class="dialog-body-wrap">
  		  <div v-if="dialogType === 'delete'">
          是否删除文章？
        </div>
        <div v-if="dialogType === 'recommend'">
          <div v-if="handle_row.is_recommend === '1'">是否设为推荐？</div>
          <div v-if="handle_row.is_recommend === '2'">是否取消推荐？</div>
        </div>
      </div>
		</common-dialog>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import CommonDialog from '@/components/CommonDialog';
import CommonPagination from '@/components/CommonPagination';
import { getArticleList, deleteArticle, editArticle, getArticleClassList } from '@/api/article-manage';
import { getLabelList } from '@/api/label-manage'

export default {
  name: 'casemanage',
  data() {
  	return {
      keyword_search: '',
      tableData: [],
      dialogVisible: false,
      dialogTitle: '',
      dialogType: '',
      handle_row: {},
      page_index: '1',  //第几页
  		page_size: '10',
      total: 0, //总条数
  	}
  },
  computed: {
  	...mapState(['imgDomain'])
  },
  mounted() {
    this._getArticleList();
    this._getArticleClassList();
    this.getAllArticlelabel();
  },
  components: {
     CommonDialog,
     CommonPagination
  },
  methods: {
    ...mapMutations(['update_article_class', 'update_article_label']),
    ...mapActions(['getAllArticlelabel']),
      handlerSearch(){
          let postData = {
              page_index: this.page_index,
              page_size: this.page_size,
              keyword_search: this.keyword_search
          };
          this.getData(postData);
      },
      clearClick(){
          let postData = {
              page_index: this.page_index,
              page_size: this.page_size,
              keyword_search: ''
          };
          this.getData(postData);
	  },
      _getArticleList() {
          let postData = {
              page_index: this.page_index,
              page_size: this.page_size,
              keyword_search: ''
          };
          this.getData(postData);
      },
      async getData(params){
          const { data, status } =await getArticleList(params);
          if (status !== 200) return
          this.tableData = data.data;
          console.log(this.tableData)
          this.total = data.total;
      },
    async _getArticleClassList() {
      let postData = {
        page_index: '1',
        page_size: '99'
      }
      const { data, status } = await getArticleClassList(postData);
      if (status !== 200 ) return
      //更新store数据
      this.update_article_class(data.data);
    },
  	addBtnClick() {
      this.$router.push('/articlehandle')
    },
    editArticleClick(row) {
      this.$router.push({
        path: '/articlehandle',
        query: {
          uuid: row.id
        }
      })
    },
  	toArticleCategoryClick() {
      this.$router.push('/articlecategory')
  	},
    toArticleLabelClick() {
      this.$router.push('/articlelabel')
    },
  	dialogCancelClick() {
      this.dialogVisible = false;
  	},
  	async dialogConfirmClick() {
      if (this.dialogType === 'delete') {
        const { status } = await deleteArticle(this.handle_row.id);
        if (status === 200) this.dialogVisible = false;
      }
      if (this.dialogType === 'recommend') {
        const { is_recommend } = this.handle_row;
        this.handle_row.is_recommend = is_recommend === '1' ? '2' : '1';
        const { status } = await editArticle(this.handle_row);
        if ( status === 200 ) this.dialogVisible = false;
      }
  	},
  	dialogClose() {
      this.dialogVisible = false;
      this.handle_row = {};
      this._getArticleList();
  	},
  	handelPagesizeChange(size) {
      this.page_size = size;
      this._getArticleList();
  	},
  	handlePageChange(page) {
      this.page_index = page;
      this._getArticleList();
  	},
    deleteArticleClick(row) {
      this.handle_row = row;
      this.dialogTitle = '删除';
      this.dialogType = 'delete';
      this.dialogVisible = true;
    },
    changeRecommendStatus(row, status) {
      this.handle_row = JSON.parse(JSON.stringify(row));
      this.dialogTitle = '文章推荐';
      this.dialogType = 'recommend';
      this.dialogVisible = true;
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/assets/styles/variables.less';
.btns-wrap {
	display: flex;
	justify-content: space-between;
}
.table-wrap {
	margin-top: 40px;
  margin-bottom: 40px;
  .project-img {
    width: 100%;
    max-height: 300px;
  }
}
.operation-wrap {
	display: flex;
	justify-content: space-around;
	color: @color-text;
	.opration-item{
		cursor: pointer;
	}
}
.dialog-body-wrap {
	text-align: center;
}
/deep/.el-table__row {
  height: 200px;
}
.input-area {
	display: inline-block;
	margin-left: 15px;
	width: 300px;
}
.searchBtn {
	margin-left: 15px;
}
</style>
